import React from "react";
import useBasketMassManagement from "../../../../../hooks/shared/useBasketMassManagement";
import IconExclamation from "../../../../../../../../common-deprecated/svg/lexus/exclamation.svg";
import * as Styles from "../styles/BasketMassManagement";

const BasketMassManagement = (): JSX.Element | null => {
    const { visible, labels, openMassManagementModal } = useBasketMassManagement();

    if (!visible || !labels) return null;
    return (
        <Styles.Wrapper>
            {labels.start}
            {labels.link && (
                <button type="button" onClick={openMassManagementModal}>
                    {labels.link}
                </button>
            )}
            <IconExclamation />
            {labels.end}
        </Styles.Wrapper>
    );
};

export default BasketMassManagement;
